<template>
  <v-container>
    <v-row>
      <v-col class="xs-12" cols="12">
        <v-card>
          <v-toolbar v-if="hasProjectPermission({
            project_id: project_id,
            ppermission: 'Update Project information'
          })">
            <v-toolbar-title class="ml-3 mr-3">{{ $t('Project.Settings.Information.ChangeName.Title') }}</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-text-field disabled :value="getProjectName(project_id)"
              :label="$t('Project.Settings.Information.ChangeName.CurrentName')"></v-text-field>
            <v-text-field v-if="hasProjectPermission({
              project_id: project_id,
              ppermission: 'Update Project information'
            })" v-model="project_name" :label="$t('Project.Settings.Information.ChangeName.NewName')" clearable
              clear-icon="delete" />
          </v-card-text>
          <v-card-actions v-if="hasProjectPermission({
            project_id: project_id,
            ppermission: 'Update Project information'
          })">
            <!-- @click="updateProjectName({'project_id': project_id, 'name': project_name})" -->
            <v-btn color="orange lighten-1 mr-2" @click="updateUObject({
              url: [
                { projects: project_id }
              ],
              update: { name: project_name }
            })">
              <v-icon class="mr-2">edit</v-icon>
              {{ $t('Project.Settings.Information.ChangeName.Button') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="xs-12" cols="12">
        <v-card>
          <v-toolbar v-if="hasProjectPermission({
            project_id: project_id,
            ppermission: 'Update Project information'
          })">
            <v-toolbar-title class="ml-3 mr-3">{{ $t('Project.Settings.Information.CopyProject.Title') }}</v-toolbar-title>
          </v-toolbar>
          <v-card-text v-if="copy_succes">
            <v-alert outlined type="success" text>
              {{ $t('Project.Settings.Information.CopyProject.Success') }}
            </v-alert>
          </v-card-text>
          <v-card-actions v-if="hasProjectPermission({
            project_id: project_id,
            ppermission: 'Update Project information'
          })">
            <TFlex style="flex-direction:column">
              <TFlex style="flex-direction:column">
                <ClickableListItem @emittedClick="copy_user = !copy_user">
                  <template #front>
                    <RadialCheckbox :is_checked="copy_user" @setActive="copy_user = !copy_user" />
                  </template>
                  <template #descriptor>
                    <StepDescriptor :step_name="'Copy all user to new project'" />
                  </template>
                </ClickableListItem>
                <ClickableListItem @emittedClick="copy_milestones = !copy_milestones">
                  <template #front>
                    <RadialCheckbox :is_checked="copy_milestones" @setActive="copy_milestones = !copy_milestones" />
                  </template>
                  <template #descriptor>
                    <StepDescriptor :step_name="'Copy milestones to new project'" />
                  </template>
                </ClickableListItem>
                <ClickableListItem @emittedClick="copy_structure = !copy_structure">
                  <template #front>
                    <RadialCheckbox :is_checked="copy_structure" @setActive="copy_structure = !copy_structure" />
                  </template>
                  <template #descriptor>
                    <StepDescriptor :step_name="'Copy PROJECT.structure to new project'" />
                  </template>
                </ClickableListItem>
                <ClickableListItem @emittedClick="copy_status = !copy_status">
                  <template #front>
                    <RadialCheckbox :is_checked="copy_status" @setActive="copy_status = !copy_status" />
                  </template>
                  <template #descriptor>
                    <StepDescriptor :step_name="'Copy WORK.packages status to WORK.packages of the new project'" />
                  </template>
                </ClickableListItem>
                <ClickableListItem @emittedClick="copy_costs = !copy_costs">
                  <template #front>
                    <RadialCheckbox :is_checked="copy_costs" @setActive="copy_costs = !copy_costs" />
                  </template>
                  <template #descriptor>
                    <StepDescriptor :step_name="'Copy WORK.packages costs to WORK.packages of the new project'" />
                  </template>
                </ClickableListItem>
                <ClickableListItem @emittedClick="add_to_business = !add_to_business">
                  <template #front>
                    <RadialCheckbox :is_checked="add_to_business" @setActive="add_to_business = !add_to_business" />
                  </template>
                  <template #descriptor>
                    <StepDescriptor :step_name="'Add the new project to your company'" />
                  </template>
                </ClickableListItem>
              </TFlex>
              <TFlex>
                <v-btn color="orange lighten-1 mr-2"
                  @click="loading = true, createUObject({
                    url: [
                      { projects: project_id }
                    ],
                    url_suffix: '/copy?show=showWithEntitiesNormalized',
                    u_object: {
                      copy_user: copy_user,
                      copy_milestones: copy_milestones,
                      copy_structure: copy_structure,
                      copy_status: copy_status,
                      copy_costs: copy_costs,
                      add_to_business: add_to_business,
                    }
                  }).then((res) => { joinProject(res.projects[0].id); updateCalenderLookupForCopyProject({ new_project_id: res.projects[0].id, old_project_id: project_id }); loading = false; copy_succes = true; })">
                  <v-icon class="mr-2">content_copy</v-icon>
                  {{ $t('Project.Settings.Information.CopyProject.Button') }}
                </v-btn>
              </TFlex>
            </TFlex>
            <v-progress-circular v-if="loading" style="position:absolute; right: 15px;" indeterminate
              color="primary"></v-progress-circular>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="xs-12" cols="12">
        <v-card>
          <v-toolbar>
            <v-toolbar-title class="ml-3 mr-3">Project External ID</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-text-field v-model="project_external_id" label="EXTERNAL.id"></v-text-field>
          </v-card-text>
          <v-card-text v-if="external_id_succes">
            <v-alert outlined type="success" text>
              EXTERNAL.id succefully updated!
            </v-alert>
          </v-card-text>
          <v-card-actions>
            <v-btn color="orange lighten-1 mr-2" @click="updateUObject({
              url: [
                { projects: project_id }
              ],
              update: { external_id: project_external_id }
            }).then(() => external_id_succes = true)">
              <v-icon class="mr-2">edit</v-icon>
              Change external id
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="xs-12" cols="12">
        <v-card>
          <v-toolbar>
            <v-toolbar-title class="ml-3 mr-3">Export Options</v-toolbar-title>
          </v-toolbar>
          <v-card-actions>
            <v-btn color="orange lighten-1 mr-2"
              @click="getXML({ project_id: project_id, project_name: project_name, file_extension: 'xml' })">
              <v-icon class="mr-2">download</v-icon>
              XML
            </v-btn>
            <v-btn color="orange lighten-1 mr-2"
              @click="getXML({ project_id: project_id, project_name: project_name, file_extension: 'tsxml' })">
              <v-icon class="mr-2">download</v-icon>
              TSXML
            </v-btn>
            <v-btn color="orange lighten-1 mr-2" @click="exportCSV({ project_id: project_id, project_name: project_name })">
              <v-icon class="mr-2">download</v-icon>
              CSV(ZIP)
            </v-btn>

            <div v-if="$store.state.Ultra.projects[project_id].histprojects.length === 0">
              <v-btn v-if="!histprojects_loading" color="orange lighten-1 mr-2" @click="loadHistoryProjects()">
                Prepare History Export
              </v-btn>
              <v-progress-circular v-if="histprojects_loading" indeterminate color="primary"></v-progress-circular>

            </div>
            <div v-else>
              <div v-if="$store.state.Ultra.projects[project_id].histprojects.length" style="display:flex;align-items: center; grid-gap: 8px;">
                <DropDownOutlinedFlat :options="historyproject_options" :value="historyproject_options[0]" :width="200"
                  :height="30" foreground_color="#fff" background_color="#000"
                  @change="selected_history_project_id = $event" />
                <v-btn color="orange lighten-1 mr-2"
                  @click="exportCSVHistory({ project_id: project_id, histproject_id: selected_history_project_id, project_name: `histproject_${project_name}_${$store.state.Ultra.histprojects[selected_history_project_id].hist_date}` })">
                  <v-icon class="mr-2">download</v-icon>
                  <!-- {{ historyproject_options }} -->
                  {{ `Export History:
                  ${$store.state.Ultra.histprojects[selected_history_project_id].hist_name}/${$store.state.Ultra.histprojects[selected_history_project_id].hist_date}`
                  }}
                
                  {{ selected_history_project_id }}
                </v-btn>
              </div>
              <TText v-else value="No History to select" />
            </div>

          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="xs-12" cols="12">
        <v-card>
          <v-toolbar>
            <v-toolbar-title class="ml-3 mr-3">Export Workpackage Images</v-toolbar-title>
          </v-toolbar>
          <v-card-actions>
            <v-btn color="orange lighten-1 mr-2"
              @click="downloadTWorkpackageImages({ project_id: project_id, project_name: project_name })">
              <v-icon class="mr-2">image</v-icon>
              Download
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-if="procoreclients_options.length > 1">
      <v-col class="xs-12" cols="12">
        <v-card>
          <v-toolbar>
            <v-toolbar-title class="ml-3 mr-3">Export to Procore</v-toolbar-title>
          </v-toolbar>
          <v-card-actions>

            <DropDownOutlinedFlat
              :options="procoreclients_options"
              :value="procoreclient"
              :width="130"
              :height="30"
              @change="procoreclient.value = $event"
            />

            <v-text-field class="ml-2 mr-2" v-model="procore_project_id" label="Procore Project Id"></v-text-field>

            <v-btn color="orange lighten-1 ml-2" :disabled="procoreclient.value === false || procore_project_id === ''"
              @click="procore_export_loading = true; updateUObject({
                  url: [
                      { businesses: getBusiness.id },
                      { procoreclients: procoreclient.value }
                    ],
                    url_suffix: '/export-workpackages-to-tasks',
                    update: { project_id: project_id, procore_project_id: procore_project_id }
                }).then(() => { procore_export_loading = false; })">
              <v-icon class="mr-2">image</v-icon>
              Export Tasks (Work Packages)
            </v-btn>

            <v-progress-circular v-if="procore_export_loading" class="ml-1" indeterminate color="orange"></v-progress-circular>

          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="xs-12" cols="12">
        <v-card>
          <v-toolbar>
            <v-toolbar-title class="ml-3 mr-3">{{ $t('Project.Settings.Information.LeaveProject.Title') }}</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-text-field v-model="project_name_delete"
              :label="$t('Project.Settings.Information.LeaveProject.Placeholder')"></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-btn color="red lighten-1 mr-2" @click="deleteUObject({
              url: [
                { projects: project_id }
              ],
              url_suffix: '/leaveproject',
              u_object: {}
            }).then(() => {
              leaveProject(project_id),
                $router.push({
                  name: 'ProjectOverView'
                });
            })">
              <v-icon class="mr-2">logout</v-icon>
              {{ $t('Project.Settings.Information.LeaveProject.Button') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import {
  mapGetters,
  mapActions
} from 'vuex';

import RadialCheckbox from '@/components/WorkPackageWIP/RadialCheckbox.component.vue';
import StepDescriptor from '@/modules/WorkPackageWIP/StepDescriptor.module.vue';
import ClickableListItem from '@/components/WorkPackageWIP/ClickableListItem.component.vue';
import DropDownOutlinedFlat from '@/components/WorkPackageWIP/DropDownOutlinedFlat.component.vue';
import TFlex from '@/components/Taktify/TFlex.component.vue';

export default {
  data() {
    return {
      project_name: '',
      project_name_delete: '',
      selected_history_project_id: -1,
      loading: false,
      histprojects_loading: false,
      copy_succes: false,
      copy_user: false,
      copy_milestones: false,
      copy_structure: false,
      copy_status: false,
      copy_costs: false,
      add_to_business: false,
      procoreclient: {
        value: false,
        text: 'Select Procore Client'
      },
      procore_project_id: '',
      procore_export_loading: false,
      external_id_succes: false,
      project_external_id: ''
    }
  },
  components: { RadialCheckbox, StepDescriptor, ClickableListItem, TFlex, DropDownOutlinedFlat },
  name: 'ProjectDelete',
  created() {
    this.project_external_id = this.project.external_id;
    this.project_name = this.getProjectName(this.project_id);
    if (this.historyproject_options.length) {
      this.selected_history_project_id = this.historyproject_options[0].value;
    }

    if (this.getUser.business) {
        this.requestUObject({
          url: [
            { businesses: this.getUser.business.id },
            { showWithEntitiesNormalized: '' }
          ]
        });
    } 

  },
  computed: {
    ...mapGetters('Project', [
      'getProjectName',
      'hasProjectPermission'
    ]),
    ...mapGetters('Ultra', [
      'getUObject',
      'getUObjects',
    ]),
    ...mapGetters('Business', [
      'getBusiness',
    ]),
    ...mapGetters('Auth', [
      'getUser',
    ]),
    project_id() {
      return parseInt(this.$route.params.project_id);
    },
    project() {
      return this.getUObject({ type: 'projects', id: this.project_id });
    },
    procoreclients_options(){
      let options = [
        {
          value: false,
          text: 'Select Procore Client'
        }
      ];

      if(this.getBusiness) {
        const procoreclients = this.getUObjects({
          type: 'procoreclients',
          ids: this.getBusiness.procoreclients
        });
  
        if (procoreclients) {
          for (let index = 0; index < procoreclients.length; index++) {
            const element = procoreclients[index];
            options.push({ text: element.name, value: element.id });
          }
        }
      }

      return options;
    },
    historyproject_options() {
      let options = [];
      const histprojects = this.getUObjects({
        type: 'histprojects',
        ids: this.project.histprojects
      });
      if (histprojects) {
        for (let index = 0; index < histprojects.length; index++) {
          const element = histprojects[index];
          options.push({ text: `${element.hist_name}/${element.hist_date}`, value: element.id });
        }
      }
      return options;
    }
  },
  methods: {
    ...mapActions('Ultra', [
      'updateUObject',
      'createUObject',
      'requestUObject',
      'deleteUObject',
      'getXML'
    ]),
    ...mapActions('Auth', [
      'leaveProject',
      'joinProject',
    ]),
    ...mapActions('ProjectCalendar', [
      'updateCalenderLookupForCopyProject',
    ]),
    ...mapActions('Project', [
      'downloadTWorkpackageImages',
      'exportCSV',
      'exportCSVHistory',
    ]),
    loadHistoryProjects() {
      this.histprojects_loading = true;
      this.requestUObject({
        url: [
          { projects: this.project_id },
          { histprojects: '' },
          { 'showWithEntitiesNormalized': '' }
        ],
        add_u_object: true,
      }).then(() => {
        if (this.historyproject_options.length) {
          this.selected_history_project_id = this.historyproject_options[0].value;
        }
        this.histprojects_loading = false;
      });
    }
  }
}
</script>
